// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ou1d","header":"PatientBlock_header__9OIRF","label":"PatientBlock_label__1aAXd","option":"PatientBlock_option__1do6C"};